import { ResponseDataGet } from "../../../../models/responseDataGet";
import { ResponseDataTest } from "../../../../models/responseDataTest";
import { agroApi } from "../../api";
import { EntInitialFilterName } from "../../../../models/filters/initialFilterName";
import { EntDirectoryInfoName } from "../../../../models/directoryInfoName";
import { Paths } from "../../../../paths";

export const fertilizerCategoryApi = agroApi.injectEndpoints({
  endpoints: (builder) => ({
	getFertilizerCategoryList: builder.query<ResponseDataGet<EntDirectoryInfoName>, EntInitialFilterName>({
	  query: (filter) => ({
		url: `${ Paths.handbooks.filter_fertilizer_category }/get-all`,
		method: "POST",
		body: JSON.stringify(filter)
	  }),
	}),
	getFertilizerCategoryById: builder.query<ResponseDataTest<EntDirectoryInfoName>, number>({
	  query: (id) => ({
		url: `${ Paths.handbooks.filter_fertilizer_category }/${ id }`,
		method: 'GET'
	  })
	}),
	addFertilizerCategory: builder.mutation<ResponseDataTest<EntDirectoryInfoName>, EntDirectoryInfoName>({
	  query: (body) => ({
		url: `${ Paths.handbooks.filter_fertilizer_category }`,
		method: "POST",
		body: JSON.stringify(body)
	  }),
	}),
	editFertilizerCategory: builder.mutation<ResponseDataTest<EntDirectoryInfoName>, EntDirectoryInfoName>({
	  query: (body,) => ({
		url: `${ Paths.handbooks.filter_fertilizer_category }`,
		method: 'PUT',
		body: JSON.stringify(body),
	  }),
	}),
	deleteFertilizerCategory: builder.mutation<ResponseDataTest<EntDirectoryInfoName>, number>({
	  query: (id) => ({
		url: `${ Paths.handbooks.filter_fertilizer_category }/${ id }`,
		method: 'DELETE',
	  }),
	}),
  }),
  overrideExisting: false,
});

export const {
  useLazyGetFertilizerCategoryListQuery,
  useAddFertilizerCategoryMutation,
  useEditFertilizerCategoryMutation,
  useDeleteFertilizerCategoryMutation
} = fertilizerCategoryApi;
